export default __webpack_public_path__ + "static/media/favicon.6f9d2d58.ico";